import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04558cac"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection D-Flex" }
const _hoisted_6 = { class: "M-Auto D-Flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = { class: "DialogSection" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_10 = { class: "DialogSection" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_12 = { class: "DialogSectionTitle" }
const _hoisted_13 = { class: "DialogSection" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_18 = { class: "DialogSection" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_20 = {
  class: "DialogSection",
  style: {"flex-direction":"row"}
}
const _hoisted_21 = { class: "DialogSection" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_24 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_CookiesImageInput, {
                Folder: _ctx.API_URL.replaceAll('.', '_'),
                onSelected: _ctx.CropImage,
                Res: 'D_Item_Image',
                style: {"border-radius":"var(--rad1)","width":"12em","height":"12em"}
              }, null, 8, ["Folder", "onSelected"])
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Name'),
              Res: 'D_Item_Name',
              Default: ''
            }, null, 8, ["Placeholder"]),
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Code'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Item_Code') && _ctx.MEMRead('D_Item_Code') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Item_Code') && _ctx.MEMRead('D_Item_Code') !== ''),
              Res: 'D_Item_Code',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"])
          ]),
          (_ctx.HaveSystem('Finance'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_CookiesNumberInput, {
                    Name: _ctx.Translate('Price'),
                    MinWidth: '3em',
                    Default: 0,
                    Min: 0,
                    Unit: 'JD',
                    Res: 'D_Item_Price'
                  }, null, 8, ["Name"])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.Translate('Specifications')), 1),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_CookiesTable, {
              onFieldEdited: _ctx.FieldEdited,
              onDeleteRow: _ctx.RemoveSpec,
              class: "Shadow1",
              TableSettings: _ctx.TableSettings,
              CookiesData: _ctx.CookiesSpecs,
              Search: '',
              Loading: (_ctx.Loading.length > 0),
              Saving: (_ctx.TableSaving.length > 0),
              Saved: _ctx.Saved
            }, null, 8, ["onFieldEdited", "onDeleteRow", "TableSettings", "CookiesData", "Loading", "Saving", "Saved"]),
            _createElementVNode("div", null, [
              _createVNode(_component_CookiesIcon, {
                class: "SQR2em P1em HoverGlow",
                ToolTip: _ctx.Translate('Add New'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.AddSpecs())),
                ID: ('Add' as IconsIDs)
              }, null, 8, ["ToolTip"])
            ])
          ]),
          _hoisted_14,
          _createVNode(_component_CookiesCheckBox, {
            Type: 'Switch',
            Res: 'D_Item_UserSelect',
            Name: _ctx.Translate('Select Per Part')
          }, null, 8, ["Name"]),
          _hoisted_15,
          _createVNode(_component_CookiesNumberInput, {
            MinWidth: '3em',
            Default: 1,
            Res: 'D_Item_PackSize',
            Name: _ctx.Translate('Pack Size'),
            Min: 1
          }, null, 8, ["Name"]),
          _hoisted_16,
          _createVNode(_component_CookiesNumberInput, {
            Min: 0,
            Default: 0,
            Res: 'D_Item_Volume',
            Name: _ctx.Translate('Volume'),
            Unit: _ctx.Translate('m3')
          }, null, 8, ["Name", "Unit"]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Description'),
              Res: 'D_Item_Description'
            }, null, 8, ["Placeholder"])
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_CookiesDropInputObject, {
              CookiesInvalidInput: !(_ctx.MEMRead('D_Item_Brand') && _ctx.MEMRead('D_Item_Brand') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Item_Brand') && _ctx.MEMRead('D_Item_Brand') !== ''),
              Name: _ctx.Translate('Brand'),
              Default: '',
              Options: _ctx.Brands,
              Selectors: ['Name'],
              Res: 'D_Item_Brand'
            }, null, 8, ["CookiesInvalidInput", "ErrorData", "Name", "Options"]),
            _createVNode(_component_CookiesIcon, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.EditCategories('Brands', 'Brands'))),
              class: "SQR2em V-Auto HoverGLow Pointer BlackWhite",
              ToolTip: _ctx.Translate('Add new Brand'),
              ID: ('Edited' as IconsIDs)
            }, null, 8, ["ToolTip"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_CookiesDropInputObject, {
              CookiesInvalidInput: !(_ctx.MEMRead('D_Item_Category') && _ctx.MEMRead('D_Item_Category') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Item_Category') && _ctx.MEMRead('D_Item_Category') !== ''),
              Name: _ctx.Translate('Category'),
              Default: '',
              Options: _ctx.Categories,
              Selectors: ['Name'],
              Res: 'D_Item_Category'
            }, null, 8, ["CookiesInvalidInput", "ErrorData", "Name", "Options"]),
            _createVNode(_component_CookiesIcon, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.EditCategories('Items', 'Items'))),
              class: "SQR2em V-Auto HoverGLow Pointer BlackWhite",
              ToolTip: _ctx.Translate('Add new category'),
              ID: ('Edited' as IconsIDs)
            }, null, 8, ["ToolTip"])
          ]),
          _hoisted_22
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Inventory_Items_Edit': 'Inventory_Items_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.DialogData.Editing ? _ctx.Translate('Save') : _ctx.Translate('Add')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}